import { Skeleton } from '@/components/ui/skeleton';
import { Card, CardContent, CardHeader } from '@/components/ui/card';

export const VehicleCardSkeleton = () => (
  <Card className="rounded-xl shadow-md border-[#DBE2EA]">
    <CardHeader className="pb-3">
      <div className="flex items-start justify-between">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-6 w-32 bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-24 bg-[#EBF4F8]" />
        </div>
        <Skeleton className="h-8 w-8 rounded-lg bg-[#EBF4F8]" />
      </div>
    </CardHeader>
    <CardContent className="space-y-3">
      <Skeleton className="h-4 w-full bg-[#EBF4F8]" />
      <Skeleton className="h-4 w-3/4 bg-[#EBF4F8]" />
      <Skeleton className="h-4 w-1/2 bg-[#EBF4F8]" />
    </CardContent>
  </Card>
);

export const DriverCardSkeleton = () => (
  <Card className="rounded-xl shadow-md border-[#DBE2EA]">
    <CardHeader className="pb-3">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <Skeleton className="h-12 w-12 rounded-full bg-[#EBF4F8]" />
          <div className="space-y-2">
            <Skeleton className="h-5 w-32 bg-[#EBF4F8]" />
            <Skeleton className="h-4 w-24 bg-[#EBF4F8]" />
          </div>
        </div>
        <Skeleton className="h-8 w-8 rounded-lg bg-[#EBF4F8]" />
      </div>
    </CardHeader>
    <CardContent className="space-y-3">
      <Skeleton className="h-4 w-full bg-[#EBF4F8]" />
      <Skeleton className="h-4 w-2/3 bg-[#EBF4F8]" />
    </CardContent>
  </Card>
);

export const MissionCardSkeleton = () => (
  <Card className="rounded-xl shadow-md border-[#DBE2EA]">
    <CardContent className="p-6 space-y-4">
      <div className="flex items-start justify-between">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-6 w-48 bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-32 bg-[#EBF4F8]" />
        </div>
        <Skeleton className="h-6 w-24 rounded-full bg-[#EBF4F8]" />
      </div>
      
      <div className="space-y-3">
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-5 rounded bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-64 bg-[#EBF4F8]" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-5 rounded bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-64 bg-[#EBF4F8]" />
        </div>
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-5 rounded bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-48 bg-[#EBF4F8]" />
        </div>
      </div>

      <Skeleton className="h-10 w-full rounded-lg bg-[#EBF4F8]" />
    </CardContent>
  </Card>
);

export const OrderCardSkeleton = () => (
  <Card className="rounded-xl shadow-md border-[#DBE2EA]">
    <CardContent className="p-6 space-y-4">
      <div className="flex items-start justify-between">
        <div className="space-y-2">
          <Skeleton className="h-6 w-40 bg-[#EBF4F8]" />
          <Skeleton className="h-4 w-24 bg-[#EBF4F8]" />
        </div>
        <Skeleton className="h-6 w-20 rounded-full bg-[#EBF4F8]" />
      </div>

      <div className="space-y-3">
        <Skeleton className="h-4 w-full bg-[#EBF4F8]" />
        <Skeleton className="h-4 w-5/6 bg-[#EBF4F8]" />
        <Skeleton className="h-4 w-2/3 bg-[#EBF4F8]" />
      </div>

      <div className="flex gap-2">
        <Skeleton className="h-10 flex-1 rounded-lg bg-[#EBF4F8]" />
        <Skeleton className="h-10 flex-1 rounded-lg bg-[#EBF4F8]" />
      </div>
    </CardContent>
  </Card>
);

export const StatsCardSkeleton = () => (
  <Card className="rounded-xl shadow-md border-[#DBE2EA]">
    <CardContent className="p-6">
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-4 w-24 bg-[#EBF4F8]" />
          <Skeleton className="h-8 w-16 bg-[#EBF4F8]" />
        </div>
        <Skeleton className="h-12 w-12 rounded-lg bg-[#EBF4F8]" />
      </div>
    </CardContent>
  </Card>
);

export const TableRowSkeleton = () => (
  <tr className="border-b border-[#DBE2EA]">
    <td className="p-4">
      <Skeleton className="h-4 w-32 bg-[#EBF4F8]" />
    </td>
    <td className="p-4">
      <Skeleton className="h-4 w-48 bg-[#EBF4F8]" />
    </td>
    <td className="p-4">
      <Skeleton className="h-4 w-24 bg-[#EBF4F8]" />
    </td>
    <td className="p-4">
      <Skeleton className="h-6 w-20 rounded-full bg-[#EBF4F8]" />
    </td>
    <td className="p-4">
      <Skeleton className="h-8 w-8 rounded bg-[#EBF4F8]" />
    </td>
  </tr>
);
